import { RowCrudStatus } from "../../common/types";
import { BotRun } from "../../../api/graphql";
import { LangStore } from "../../../store";

export type BotRunValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  runNumber: number;
};

export type BotRunErrorsType = {
  runNumber?: { message: string; fieldLabel: string };
};

export function BotRunValuesInit(): BotRunValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    runNumber: 0,
  };
}

export type BotRunType = BotRun | BotRunValuesType;

export function botRunDisplayId(
  source: Partial<BotRun>,
  _langStore: LangStore
) {
  return (
    (source.botType ?? _langStore.emptyStringSymbol) +
    "-" +
    (source.runNumber?.toString() ?? _langStore.emptyStringSymbol)
  );
}

export function getBotRunValues(
  source: BotRunType,
  _langStore: LangStore,
  _duplicated: boolean = false
): BotRunValuesType {
  const entityValues = BotRunValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : botRunDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.runNumber = source.runNumber || 0;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
